export const SERVICE = 'LOADING'
